import { render, staticRenderFns } from "./NotSuitedList.vue?vue&type=template&id=0092e4db&scoped=true"
import script from "./NotSuitedList.vue?vue&type=script&lang=js"
export * from "./NotSuitedList.vue?vue&type=script&lang=js"
import style0 from "./NotSuitedList.vue?vue&type=style&index=0&id=0092e4db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0092e4db",
  null
  
)

export default component.exports